import Reflux from "reflux";
import * as Immutable from "immutable";
import { qualifyUrl } from "util/URLUtils";
import fetch from "logic/rest/FetchProvider";
import { singletonStore } from "logic/singleton";
import PaginationURL from "util/PaginationURL";
import AuthenticationActions from "../actions/AuthenticationActions";
import Team from "../../security/logic/Team";
const apiPrefix = "/plugins/org.graylog.plugins.security";
const ApiRoutes = {
  AuthenticationController: {
    loadTeamsPaginated: (authBackendId) => ({
      url: `${apiPrefix}/team-sync/services/${authBackendId}/backend/teams`
    }),
    triggerTeamSync: (backendId) => ({ url: `${apiPrefix}/team-sync/trigger/${backendId}` })
  }
};
const AuthenticationStore = singletonStore(
  "enterprise.Authentication",
  () => Reflux.createStore({
    listenables: [AuthenticationActions],
    loadTeamsPaginated(authBackendId, { page: newPage, perPage: newPerPage, query: newQuery }) {
      const url = PaginationURL(
        ApiRoutes.AuthenticationController.loadTeamsPaginated(authBackendId).url,
        newPage,
        newPerPage,
        newQuery
      );
      const promise = fetch("GET", qualifyUrl(url)).then(
        ({ teams, context, page, per_page: perPage, query, count, total }) => ({
          list: Immutable.List(teams.map((user) => Team.fromJSON(user))),
          context: {
            roles: Immutable.Map(context == null ? void 0 : context.roles),
            users: Immutable.Map(context == null ? void 0 : context.users)
          },
          pagination: {
            page,
            perPage,
            query,
            count,
            total
          }
        })
      );
      AuthenticationActions.loadTeamsPaginated.promise(promise);
      return promise;
    },
    triggerTeamSync(backendId) {
      const promise = fetch("POST", qualifyUrl(ApiRoutes.AuthenticationController.triggerTeamSync(backendId).url)).then(
        ({
          success,
          message,
          errors,
          created_teams: createdTeams,
          deleted_teams: deletedTeams,
          updated_teams: updatedTeams
        }) => ({
          success,
          message,
          errors,
          createdTeams,
          deletedTeams,
          updatedTeams
        })
      );
      AuthenticationActions.triggerTeamSync.promise(promise);
      return promise;
    }
  })
);
export { AuthenticationActions, AuthenticationStore };
export default AuthenticationStore;
